// DO NOT EDIT -- generated from fs/services/dx-objects/overlays.proto

import * as segment from '../../api/segment';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export namespace OverlaysPublic {

  export const CreateUnnamedOverlayEndpoint = "/grpc/dx_objects.OverlaysPublic/CreateUnnamedOverlay";
  export function CreateUnnamedOverlay(sender: (req: CreateUnnamedOverlayRequest, endpoint: string) => Promise<CreateUnnamedOverlayResponse>, req: CreateUnnamedOverlayRequest): { promise: () => Promise<CreateUnnamedOverlayResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUnnamedOverlayEndpoint),
      endpoint: CreateUnnamedOverlayEndpoint
    };
  }

  export const GetUnnamedOverlayEndpoint = "/grpc/dx_objects.OverlaysPublic/GetUnnamedOverlay";
  export function GetUnnamedOverlay(sender: (req: GetUnnamedOverlayRequest, endpoint: string) => Promise<GetUnnamedOverlayResponse>, req: GetUnnamedOverlayRequest): { promise: () => Promise<GetUnnamedOverlayResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUnnamedOverlayEndpoint),
      endpoint: GetUnnamedOverlayEndpoint
    };
  }
}

export interface CreateUnnamedOverlayRequest {
  orgId: string;
  hash: string;
  overlay: UnnamedOverlay | null;
}

export interface CreateUnnamedOverlayResponse {
  hash: string;
}

export interface GetUnnamedOverlayRequest {
  orgId: string;
  hash: string;
}

export interface GetUnnamedOverlayResponse {
  overlay: UnnamedOverlay | null;
}

export interface UnnamedOverlay {
  segments: visualizationsettings.SegmentSettings[];
  deps: segment.DependentEventFilter[];
  timeRange: segment.TimeRange | null;
  id: string;
}
